import React from "react";
import PreviewFormGenerator from "../../../core/preview-form-generator";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  floatEngineActionConfig,
  floatEngineFormConfig,
} from "../float-engine-movements/config";
import { Grid } from "@mui/material";

const FloatEngineDetails = ({ detail, setDetail }) => {
  const { data } = detail;
  return (
    <div>
      <div className="page-body page-load">
        <div className=" view-detailed-ticket">
          <ArrowBackIcon
            sx={{ cursor: "pointer", marginRight: "20px" }}
            onClick={() => {
              setDetail({
                isOpen: false,
                data: {},
              });
            }}
          />
          <div className="border-r">
            <p className="tab-name">Float Engine Movements</p>
            <p className="section-name">Float Engine</p>
          </div>
          <div>
            <p className="tab-name">Ticket ID</p>
            <p className="section-name">{data?.ticketId}</p>
          </div>
        </div>

        <Grid container spacing={3}>
          <Grid item md={12}>
            <div className="form-con" style={{ margin: "0px", width: "100%" }}>
              <PreviewFormGenerator
                formConfig={floatEngineFormConfig}
                formValues={data}
              />
              <PreviewFormGenerator
                formConfig={floatEngineActionConfig}
                formValues={data}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default FloatEngineDetails;
